import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=6c11dc3f"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports